const state = {
  isAuthInit: false,
  isSignIn: false,
  userProfile: null
}

export default state
